var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout",attrs:{"id":"theme"}},[(_vm.$isLoggedIn && _vm.$store.getters['event/currentEventId'])?_c('AppHeader'):_vm._e(),_c('main',{staticClass:"default-layout__content main _container"},[_c('router-view')],1),(!_vm.$store.getters['event/isMeroPlaceVisible'])?_c('AppMeroPlace'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }